import { Box } from "@chakra-ui/react";
import CardDefault from "components/Cards/CardDefault";
import ContentItem from "components/ContentItem";
import { Row, Col } from "antd";
import { RelatorioAuditoriaItem } from "core/features/relatorios/typings";
import moment from "moment";
import { getColorAcaoAuditoria } from "../../utils";

interface ItemAuditoriaProps {
  item: RelatorioAuditoriaItem;
}

export default function ItemAuditoria({ item }: ItemAuditoriaProps) {
  return (
    <>
      <CardDefault pb={4} mb={2} overflow="visible" position="relative">
        <Box as={Row} flex={1} gutter={8}>
          <Box as={Col} xs={6}>
            <ContentItem
              fontWeightTitle="bold"
              colorTitulo="#1a202c"
              fontSizeTitulo="12px"
              fontSizeDescricao="12px"
              fontWeightDescricao="bold"
              titulo="Ação"
              colorDescricao={getColorAcaoAuditoria(item.acao)}
              descricao={item.acao}
            />
          </Box>

          <Box as={Col} xs={4}>
            <ContentItem
              titulo="Data"
              fontWeightTitle="bold"
              colorTitulo="#1a202c"
              fontSizeTitulo="12px"
              fontSizeDescricao="12px"
              descricao={
                item.data
                  ? moment(item.data).format("DD/MM/YYYY [às] HH:mm")
                  : "--"
              }
            />
          </Box>

          <Box as={Col} xs={6}>
            <ContentItem
              fontWeightTitle="bold"
              colorTitulo="#1a202c"
              fontSizeTitulo="12px"
              fontSizeDescricao="12px"
              titulo="Autor"
              descricao={item.pessoa?.nome ?? "--"}
            />
          </Box>

          <Box as={Col} xs={6}>
            <ContentItem
              fontWeightTitle="bold"
              colorTitulo="#1a202c"
              fontSizeTitulo="12px"
              fontSizeDescricao="12px"
              titulo="Cliente"
              descricao={item.tenant?.nome ?? "--"}
            />
          </Box>
        </Box>
      </CardDefault>
    </>
  );
}
